import { render, staticRenderFns } from "./GproAvatar.vue?vue&type=template&id=fc21ebb2&"
import script from "./GproAvatar.vue?vue&type=script&lang=js&"
export * from "./GproAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports